import Vue from 'vue';
import VueMoment from 'vue-moment';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import 'babel-polyfill';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import labels from '@/common/locale';
import StorageService from '@/common/storage.service'; // eslint-disable-line no-unused-vars
import { crop } from '@/common/filter'; // eslint-disable-line
import LanguageService from '@/common/language.service'; // eslint-disable-line no-unused-vars
import App from './App.vue';
import router from './router';
import Modal from './components/Modal/Modal.vue';

Vue.use(VueI18n);
Vue.prototype.axios = axios;

Vue.component('v-select', vSelect);
Vue.component('modal', Modal);
Vue.use(VueMoment);

Vue.config.productionTip = false;

// enable localisation
const i18n = new VueI18n({
  locale: LanguageService.getCurrentTYPO3Language(),
  fallbackLocale: 'de',
  messages: labels,
});

// enable Sentry
Raven
  .config('https://e40722ab10134d329935adca2f050b17@sentry.andersundsehr.com/10', {
    environment: process.env.NODE_ENV,
  })
  .addPlugin(RavenVue, Vue)
  .install();

new Vue({
  router,
  render: h => h(App),
  i18n,
}).$mount('#app');

// locale change for testing
// i18n.locale = 'en';
